import { Button, Icon, Typography } from '@packages/ui/shared';
import { Modal } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';

/**
 * Props for the {@link ConfirmDeleteAssetModal} component.
 */
export type ConfirmDeleteAssetModalProps = {
    /** Whether the delete operation is currently in progress. */
    isLoading: boolean;

    /** Callback invoked when the user cancels the deletion. */
    onCancel: () => void;

    /** Callback invoked when the user confirms the deletion. */
    onConfirm: () => void;

    /** Whether the modal is currently visible. */
    show: boolean;
};

/**
 * Confirmation modal shown before deleting a case-level asset attachment.
 * Displays a warning message and provides cancel/delete buttons so that
 * accidental deletions are prevented.
 *
 * @param props - {@link ConfirmDeleteAssetModalProps}
 * @returns the confirm delete asset modal JSX
 */
export function ConfirmDeleteAssetModal({ isLoading, onCancel, onConfirm, show }: ConfirmDeleteAssetModalProps) {
    const classes = useStyles();

    return (
        <Modal centered dialogClassName={classes.dialog} onHide={onCancel} show={show}>
            <Modal.Header closeButton>
                <Typography variant="h4">Delete Attachment?</Typography>
            </Modal.Header>

            <Modal.Body>
                <div className="d-flex">
                    <Icon name="warning" />
                    <div className="d-flex flex-column ml-3">
                        {/* eslint-disable-next-line no-restricted-syntax -- single-property style (convention exception) */}
                        <Typography style={{ marginBottom: 10 }} variant="h5">
                            Are you sure you want to delete this attachment?
                        </Typography>
                        <Typography variant="lead">Deleting attachments cannot be undone.</Typography>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button onPress={onCancel} title="Cancel" variant="link" />
                <Button
                    isLoading={isLoading}
                    onPress={onConfirm}
                    // eslint-disable-next-line no-restricted-syntax -- single-property style (convention exception)
                    style={{ marginLeft: 20 }}
                    title="Delete"
                    variant="danger"
                />
            </Modal.Footer>
        </Modal>
    );
}

const useStyles = createUseStyles({
    dialog: {
        maxWidth: 'none',
        width: 558,
    },
});
